import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { IconDashboard } from '@tabler/icons';

import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import GroupRoundedIcon from '@mui/icons-material/GroupRounded';
import ChatIcon from '@mui/icons-material/Chat';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';

// constant
const icons = {
  ReceiptLongIcon,
  SubscriptionsIcon,
  IconDashboard,
  CollectionsOutlinedIcon,
  ReceiptLongIcon,
  AdminPanelSettingsOutlinedIcon,
  GroupRoundedIcon,
  MonitorHeartOutlinedIcon,
  FitnessCenterIcon
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const trainer = [
  {
    id: 'trainerDashboard',
    title: 'Dashboard',
    type: 'group',
    userType: [4, 5],
    children: [
      {
        id: 'default',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard',
        icon: icons.IconDashboard,
        breadcrumbs: false
      }
    ]
  },
  {
    id: 'administrationHead',
    title: 'Administration',
    type: 'group',
    userType: [5],
    children: [
      {
        id: 'trainers',
        title: 'Trainers',
        type: 'item',
        url: '/trainers',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false
      },
      {
        id: 'recovery-board',
        title: 'Recovery Board',
        type: 'item',
        url: '/recovery-board',
        icon: icons.MonitorHeartOutlinedIcon,
        breadcrumbs: false
      },
      {
        id: 'posture-library',
        title: 'Posture Library',
        type: 'item',
        url: '/posture-library',
        icon: icons.MonitorHeartOutlinedIcon,
        breadcrumbs: false
      }
    ]
  },

  {
    id: 'trainerLibrary',
    title: 'Library',
    type: 'group',
    userType: [4, 5],
    children: [
      {
        id: 'trainerRoutine',
        title: 'Exercises',
        type: 'item',
        url: '/exercises-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'trainerWarmup',
        title: 'Warm Up',
        type: 'item',
        url: '/warmups-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'trainerCoolDown',
        title: 'Cool Down',
        type: 'item',
        url: '/cool-downs-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      },
      {
        id: 'foods',
        title: 'Food',
        type: 'item',
        url: '/foods-library',
        icon: icons.ReceiptLongIcon,
        breadcrumbs: false
      }
    ]
  },

  {
    id: 'trainerOneToOne',
    title: '1 to 1 training',
    type: 'group',
    userType: [4, 5],
    children: [
      {
        id: 'trainerTrainingRequests',
        title: 'Training Requests',
        type: 'item',
        url: '/training-requests',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false
      },
      {
        id: 'assessments',
        title: 'Assessments',
        type: 'item',
        url: '/assessments',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: false
      },
      {
        id: 'clients',
        title: 'Clients (Active)',
        type: 'item',
        url: '/clients',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: true
      },
      {
        id: 'expired-clients',
        title: 'Clients (Expired)',
        type: 'item',
        url: '/expired-clients',
        icon: icons.GroupRoundedIcon,
        breadcrumbs: true
      },

      {
        id: 'trainerPrograms',
        title: 'Programs',
        type: 'item',
        url: '/programs',
        icon: ContentPasteIcon,
        breadcrumbs: true
      },
      {
        id: 'trainerNutritions',
        title: 'Nutritions',
        type: 'item',
        url: '/nutritions',
        icon: ContentPasteIcon,
        breadcrumbs: true
      },
      {
        id: 'trainerNutritionCalculator',
        title: 'Calculator',
        type: 'item',
        url: '/nutrition-calculator',
        icon: ContentPasteIcon,
        breadcrumbs: true
      }
    ]
  },

  // Live, in-person sessions. These clients are NOT app users - they have no
  // account, subscription or training request - so this is its own section
  // rather than another entry under "1 to 1 training".
  {
    id: 'liveTraining',
    title: 'Live Sessions',
    type: 'group',
    // 1 is here because the owner works in the panel as a Super Admin, not as
    // the head-coach account. The sidebar's userType gate runs BEFORE the
    // "Super Admin bypass" in MenuList, and that bypass only skips permission
    // checks - so without an explicit 1 a Super Admin cannot see this at all.
    userType: [1, 4, 5],
    children: [
      {
        id: 'liveClients',
        title: 'Live Clients',
        type: 'item',
        url: '/live-training',
        icon: icons.FitnessCenterIcon,
        breadcrumbs: true
      }
    ]
  },

  {
    id: 'trainerContent',
    title: 'Content',
    type: 'group',
    userType: [4, 5],
    children: []
  },

  {
    id: 'trainerChat',
    title: 'Chat',
    type: 'group',
    userType: [4, 5],
    children: [
      {
        id: 'trainerChat',
        title: 'Chat',
        type: 'item',
        url: '/chat',
        icon: ChatIcon,
        breadcrumbs: true
      }
    ]
  },
  {
    id: 'emptyTrainer',
    title: '',
    type: 'group',
    userType: [4, 5],
    children: [
      {
        id: 'empty11',
        title: '',
        type: 'empty',
        url: '#',
        icon: 'empty',
        breadcrumbs: false,
        permissions: ['']
      },
      {
        id: 'empty12',
        title: '',
        type: 'empty',
        url: '#',
        icon: 'empty',
        breadcrumbs: false,
        permissions: ['']
      }
    ]
  }
];
export default trainer;
